  import { useLocation } from "react-router";
  import SkeletonLoader from "../../../utilites/SkeltonLoader";
  import BreadCrumb from "../../../pages/breadcrumb/BreadCrumb";
  import FormGeneratorPermission from "./form-generator-permssion";
import { useState } from "react";

  const sections= [
          {
              "section_uuid": "578a9e67-f5a3-4bb9-8670-d315c6f84f75",
              "name": "Registration",
              "description": "registration of description",
              "order": 1,
              "property": {
                  "display_details": true,
                  "display_field_number": false,
                  "section_permission": ""
              },
              "persmissions": {
          "view": [
            {
              role_id: 2,
              slug: 'in-bound-create',
              portal: 2
            }
          ],
          fill: [
            {
              role_id: 2,
              slug: 'in-bound-create',
              portal: 2
            }
          ]
        },
              "fields": [
                  {
                      "input_uuid": "8d8c09c0-c1f2-4c7a-b21c-3772de0adc26",
                      "label": "Untitled field",
                      "placeholder": "Enter field title",
                      "order": 3,
                      "property": {
                          "general": {
                              "required": true,
                              "display_visuals_line": "none",
                              "raise_query": false
                          },
                          "note": {
                              "message_note": "wggg"
                          },
                          "field_layout": 12,
                          "field_type": "Input Text",
                          "input_text": {
                              "default_val": "",
                              "restrict_number": "",
                              "restrict_spl_char": "",
                              "restrict_email": "",
                              "max_limit": "",
                              "max_limit_range": "",
                              "min_limit": "",
                              "min_limit_range": ""
                          }
                      },
                      "value": ""
                  },
                  {
                      "input_uuid": "7e55a197-dd92-4393-bda3-3e10f2d1b9a0",
                      "label": "last name",
                      "placeholder": "Enter field title",
                      "order": 2,
                      "property": {
                          "general": {
                              "required": false,
                              "display_visuals_line": "none",
                              "raise_query": false
                          },
                          "field_layout": 12,
                          "field_type": "Input Email",
                          "input_email": {
                              "email_allowed": ""
                          }
                      },
                      "value": ""
                  },
                  {
                      "input_uuid": "d3832b93-f66e-4a68-95ec-cd52864ae933",
                      "label": "name",
                      "placeholder": "Enter field title",
                      "order": 1,
                      "property": {
                          "general": {
                              "required": false,
                              "display_visuals_line": "none",
                              "raise_query": false
                          },
                          "field_layout": 12,
                          "field_type": "Input Text",
                          "input_text": {
                              "default_val": "",
                              "restrict_number": "",
                              "restrict_spl_char": "",
                              "restrict_email": "",
                              "max_limit": "",
                              "max_limit_range": "",
                              "min_limit": "",
                              "min_limit_range": ""
                          },
                          "options": {
                              "field_uuid": "d3832b93-f66e-4a68-95ec-cd52864ae933",
                              "field_id": 1,
                              "options": [
                                  {
                                      "id": 1,
                                      "option_uuid": "4ef76cd9-f037-46c3-b6a2-2c9c9c13c1c6",
                                      "input_field_uuid": "d3832b93-f66e-4a68-95ec-cd52864ae933",
                                      "label": "Updated Option 2-1",
                                      "value": "updated_option2",
                                      "order_num": 1
                                  },
                                  {
                                      "id": 2,
                                      "option_uuid": "126b99bb-6fa2-487e-8838-0243e5998d6a",
                                      "input_field_uuid": "d3832b93-f66e-4a68-95ec-cd52864ae933",
                                      "label": "Dr. riya",
                                      "value": "riya",
                                      "order_num": 1
                                  }
                              ]
                          }
                      },
                      "value": ""
                  }
              ]
          },
          {
              "section_uuid": "b12c0f5c-b29c-4f5a-8ca3-8afaa6558432",
              "name": "The new section to be test",
              "description": "Enter section title",
              "order": 2,
              "property": {
                  "display_details": true,
                  "display_field_number": false,
                  "section_permission": ""
              },
              "persmissions": {
          "view": [
            {
              role_id: 2,
              slug: 'in-bound-edit',
              portal: 2
            }
          ],
          fill: [
            {
              role_id: 2,
              slug: 'in-bound-edit',
              portal: 2
            }
          ]
        },
              "fields": [
                  {
                      "input_uuid": "04937e46-9b64-42d1-820c-dfb0b7325761",
                      "label": "Okay test ",
                      "placeholder": "Enter field title",
                      "order": 1,
                      "property": {
                          "general": {
                              "required": false,
                              "display_visuals_line": "none",
                              "raise_query": false
                          },
                          "field_layout": 12,
                          "field_type": "Input Text",
                          "input_text": {
                              "default_val": "",
                              "restrict_number": "",
                              "restrict_spl_char": "",
                              "restrict_email": "",
                              "max_limit": "",
                              "max_limit_range": "",
                              "min_limit": "",
                              "min_limit_range": ""
                          }
                      },
                      "value": ""
                  }
              ]
          },
          {
              "section_uuid": "b12c0f5c-b29c-4f5a-8ca3-8afaa6558432",
              "name": "The new section to be test",
              "description": "Enter section title",
              "order": 2,
              "property": {
                  "display_details": true,
                  "display_field_number": false,
                  "section_permission": ""
              },
              "persmissions": {
          "view": [
            {
              role_id: 2,
              slug: 'in-bound-edit',
              portal: 2
            }
          ],
          fill: [
            {
              role_id: 2,
              slug: 'in-bound-edit',
              portal: 2
            }
          ]
        },
              "fields": [
                  {
                      "input_uuid": "04937e46-9b64-42d1-820c-dfb0b7325761",
                      "label": "Okay test ",
                      "placeholder": "Enter field title",
                      "order": 1,
                      "property": {
                          "general": {
                              "required": false,
                              "display_visuals_line": "none",
                              "raise_query": false
                          },
                          "field_layout": 12,
                          "field_type": "Input Text",
                          "input_text": {
                              "default_val": "",
                              "restrict_number": "",
                              "restrict_spl_char": "",
                              "restrict_email": "",
                              "max_limit": "",
                              "max_limit_range": "",
                              "min_limit": "",
                              "min_limit_range": ""
                          }
                      },
                      "value": ""
                  }
              ]
          }
      ]

  const AssignSectionPermission = () => {
    const location = useLocation();
    const BreadCrumbData = location.state || [];
    const [formData,setFormData]=useState({})
    let isLoading = false
    const onSubmit=(values)=>{
console.log('check for values is here', values, 'Check form data', formData)
    }
    return (
      <div className="!p-6">
        {isLoading
          ? <SkeletonLoader rowCount={1} isTable={false} width="100%" height={100} />
          : <>    {BreadCrumbData && BreadCrumbData?.length > 0 &&
            <div className="mb-4"><BreadCrumb BreadCrumbsListing={BreadCrumbData} /></div>}
            <FormGeneratorPermission formJson={sections} isSectionsPermission={true} loading={false} formData={ {sections:sections}} setFormData={setFormData} onSubmit={onSubmit}/>
          </>}

      </div>
    );
  };

  export default AssignSectionPermission;
